var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProposalSentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.437,
    height: 202.878,
    viewBox: "0 0 177.437 202.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e6e6e6;}.b{fill:#fff;}.c{fill:#4eb0b9;}.d{fill:#004666;}.e{fill:#dfdfdf;}.f{fill:#6edfe7;}.g{fill:#f2f2f2;}.h{fill:#d69b81;}.i{fill:#2f2e41;}.j{fill:#b8dfe3;}.k{fill:#ebd7a0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49.505)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M260.168,540.344l-3.76-6.076a89.941,89.941,0,0,1,4.169-9.241l2.469,2.078-1.925-3.111c1.969-3.69,3.506-6.008,3.506-6.008s7.537,12.422,9.876,25.461l-5.135,7.6,5.6-4.342a36.389,36.389,0,0,1,.211,4.568c-.31,15.38-5.584,27.747-11.78,27.622s-10.968-12.694-10.659-28.074A47.9,47.9,0,0,1,255.6,536.5Z",
    transform: "translate(-185.876 -394.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M207.821,562.8l-6.36-3.258a89.941,89.941,0,0,1-1.207-10.065l3.187.5-3.256-1.668c-.222-4.176-.1-6.956-.1-6.956s12.873,6.738,21.615,16.691l-.469,9.157,2.552-6.613a36.388,36.388,0,0,1,2.541,3.8c7.685,13.326,9.563,26.639,4.194,29.735s-15.951-5.2-23.636-18.523a47.9,47.9,0,0,1-4.957-13.734Z",
    transform: "translate(-150.545 -410.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M272.134,716.238c-7.328.469-15.313-.027-23.807,0V696.79a85.809,85.809,0,0,0,23.807,0Z",
    transform: "translate(-182.925 -514.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M530.117,112.836l-77.769,12.522-.33-75.6L529.787,0Z",
    transform: "translate(-303.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M530.25,134.987l-67.224,14.5V86.216L530.25,49.73Z",
    transform: "translate(-310.558 -33.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M531.714,109.041l-56.679,25.382v-8.906l56.679-28Z",
    transform: "translate(-318.612 -65.406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M531.714,181.406,475.035,201.4V192.61l56.679-22.575Z",
    transform: "translate(-318.612 -114.045)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M693.5,313.846a.212.212,0,0,1,.409-.013l.918,2.892,1.1,3.465a.212.212,0,0,1-.121.26l-2.125.885-1.867.778a.212.212,0,0,1-.288-.247l1.021-4.148Z",
    transform: "translate(-515.181 -257.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M683.514,379.124a.351.351,0,0,1,.674-.022l.769,2.424,1.061,3.344a.351.351,0,0,1-.2.43l-2.008.837-1.615.673a.35.35,0,0,1-.475-.407l.956-3.882Z",
    transform: "translate(-508.602 -301.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M531.714,252.034l-56.679,14.6v-9.328l56.679-17.343Z",
    transform: "translate(-318.612 -160.947)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M791.168,289.263c0,1.985-.889,3.958-1.977,4.4s-1.946-.786-1.946-2.739.867-3.917,1.946-4.391S791.168,287.278,791.168,289.263Z",
    transform: "translate(-579.384 -239.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M792.478,294.793a1.682,1.682,0,0,1-.659,1.474c-.362.152-.656-.258-.656-.916a1.688,1.688,0,0,1,.656-1.473C792.183,293.722,792.478,294.132,792.478,294.793Z",
    transform: "translate(-582.013 -244.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M791.168,359.314c0,1.985-.889,3.958-1.977,4.4s-1.946-.786-1.946-2.739.867-3.917,1.946-4.391S791.168,357.329,791.168,359.314Z",
    transform: "translate(-579.384 -286.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M792.478,364.845a1.682,1.682,0,0,1-.659,1.474c-.362.152-.656-.258-.656-.916a1.688,1.688,0,0,1,.656-1.473C792.183,363.774,792.478,364.183,792.478,364.845Z",
    transform: "translate(-582.013 -291.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M791.168,429.365c0,1.985-.889,3.958-1.977,4.4s-1.946-.786-1.946-2.739.867-3.917,1.946-4.391S791.168,427.381,791.168,429.365Z",
    transform: "translate(-579.384 -333.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M792.478,434.9a1.682,1.682,0,0,1-.659,1.474c-.362.152-.656-.258-.656-.916a1.688,1.688,0,0,1,.656-1.473C792.183,433.825,792.478,434.234,792.478,434.9Z",
    transform: "translate(-582.013 -338.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M699.514,437.169a.351.351,0,0,1,.675-.022l.769,2.424,1.061,3.344a.351.351,0,0,1-.2.43l-2.008.837-1.615.673a.35.35,0,0,1-.475-.407l.956-3.882Z",
    transform: "translate(-519.333 -340.139)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M656.936,403.214,660,400.386s6.94-4.781,4.516-7.409-7.31,3.5-7.31,3.5l-3.032,1.986Z",
    transform: "translate(-490.133 -310.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M535.4,413.54,533.618,416s-2.5,9.6,10.135,10.108c0,0,16.131,7.82,20.124,2.921s15.012-16.685,15.012-16.685l-6.482-6.587L559.2,419.561l-12.814-6.421S539.785,409.5,535.4,413.54Z",
    transform: "translate(-409.139 -319.248)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M323.859,424.679l-16.724,61.615,2.107.421,17.566-62.037Z",
    transform: "translate(-210 -283.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M413.486,424.679l16.723,61.615-2.107.421-17.566-62.037Z",
    transform: "translate(-279.352 -283.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M384.795,419.123l2.8,62.982,2.435.108L386.9,418.28Z",
    transform: "translate(-262.087 -279.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M529.374,556.056c0,1.6-6.178,3.312-14.287,3.863-8.7.591-16.241-.369-16.241-2.185s7.538-3.6,16.241-3.971C523.2,553.424,529.374,554.459,529.374,556.056Z",
    transform: "translate(-389.951 -417.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M578.733,528.053l4.214,2.95s18.119,13.063,16.433,18.119S588.424,574.4,588.424,574.4l-11.8-3.792,13.484-21.49-7.163-6.742-3.792-9.27Z",
    transform: "translate(-438.119 -401.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M522.96,501.887s-8.427,13.063-3.371,16.855,19.383,18.54,19.383,18.54l2.95,6.742,10.534,34.131,13.063-6.742-11.8-26.546s-1.264-9.692-5.478-15.169-5.9-13.484-5.9-13.484l1.264-3.792-7.545-12.072Z",
    transform: "translate(-398.781 -382.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M571.45,656.763l-7.574-2.3s-8.178-.337-7.757,2.613,7.163,22.333,9.27,21.069.421-7.163.421-7.163Z",
    transform: "translate(-424.355 -486.048)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M387.09,237.21l-4.214,4.635,6.742,10.956,2.95-8.427Z",
    transform: "translate(-256.8 -159.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M541.514,404.276l-7.484-12.394-2.629.6v4.214l-.843,35.4,13.905-2.107S545.306,407.225,541.514,404.276Z",
    transform: "translate(-407.221 -309.943)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M496.524,405.067,490.2,393.69l-5.478,2.528-9.692,39.609-5.9,11.377s19.383,9.692,24.018,0,5.056-31.182,5.056-31.182Z",
    transform: "translate(-366.024 -311.155)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M491.3,402.785l-2.528-1.685s-9.692-2.107-9.692,10.534c0,0-7.163,16.434-2.107,20.226s17.276,14.327,17.276,14.327l6.321-6.742L486.242,426.8l5.9-13.063S495.512,407,491.3,402.785Z",
    transform: "translate(-370.069 -316.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M533.118,523.325l2.95,2.95s5.057,6.742,7.585,4.214-3.792-7.163-3.792-7.163l-2.107-2.95Z",
    transform: "translate(-408.938 -396.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M561.106,417.907l7.23,17.729s2.95,8.849,2.95,12.22v9.27l-8.006-10.534S558.932,419.14,561.106,417.907Z",
    transform: "translate(-427.302 -327.398)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M630.708,717.632s-2.087,8.219.652,8.915,25.727,1.284,25.741-2.6-14.919-7.094-14.919-7.094l-5.517-3.54Z",
    transform: "translate(-473.882 -525.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 7.585,
    cy: 7.585,
    r: 7.585,
    transform: "translate(127.972 70.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M557.29,353.741s1.482-6.42,0-7.9v.988s-.988-3.457-2.963-2.469c0,0-2.469-1.975-2.963-.988-2.906-2.627-15.79-.164-9.536,13.629,0,0,1.14-4.246,1.14-2.764a32.242,32.242,0,0,0,3.457-3.951C546.919,349.3,555.314,355.716,557.29,353.741Z",
    transform: "translate(-413.645 -276.782)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposalSentIcon);
export default __webpack_public_path__ + "static/media/proposal-sent-icon.56e29c6ef21c20fb688ac1c28b74c193.svg";
export { ForwardRef as ReactComponent };